import { useCallback, useMemo } from "react";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";
import { deepClone } from "src/utils";

import { type IRevAud } from "./RevAud.types";
import RevAudItemRow from "./RevAudItemRow";

interface Props {
  data: IRevAud[];
  loading: boolean;
  refetch: () => Promise<void>;
  reviewerCell?: { label: string };
}

const headers = [
  {
    name: "type",
    label: "Type",
    style: { width: "15%" },
  },
  {
    name: "start",
    label: "Access Start Period",
    style: { width: "15%" },
  },
  {
    name: "end",
    label: "Access End Period",
    style: { width: "15%" },
  },
  {
    name: "revstart",
    label: "Entries Start Period",
    style: { width: "15%" },
  },
  {
    name: "revend",
    label: "Entries End Period",
    style: { width: "15%" },
  },
  {
    name: "date",
    label: "Reviewed Date",
    style: { width: "15%" },
  },
  {
    name: "status",
    label: "Status",
    style: { width: "15%" },
  },
  {
    name: "blank",
    label: "",
    style: { width: "40%", borderLeft: "none" },
  },
];

const RevAudTable = ({ data, loading, refetch, reviewerCell }: Props) => {
  const renderRow = useCallback(
    ({ row }: { row: IRevAud }) => (
      <RevAudItemRow row={row} refetch={refetch} reviewerCell={reviewerCell} />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
    [refetch],
  );
  const parsedHeaders = useMemo(() => {
    const temp = deepClone(headers);
    if (reviewerCell) {
      temp.splice(temp.length - 1, 0, reviewerCell);
    }
    return temp;
  }, [reviewerCell]);
  return (
    <ScrollableTable
      data={data}
      keyExtractor={item => item.id}
      headers={parsedHeaders}
      renderRow={renderRow}
      loading={loading}
      sortable
    />
  );
};

export default RevAudTable;
